import { Link } from "react-router-dom";
import { allGenres } from "@/lib/movies";

export default function SiteFooter() {
  const hotGenres = allGenres.slice(0, 6);

  return (
    <footer className="mt-16 md:mt-24 border-t border-background-200/70 bg-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-foreground-50 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-50">淫乱小镇</span>
                <span className="font-label text-[10px] tracking-[0.32em] text-foreground-500 mt-1">
                  FILM ARCHIVE
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-500">
              一个专注影视作品剧情介绍与深度解析的内容站。我们把散落在各集各幕里的线索重新整理，帮助你在看完之后，还能再多懂一点。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {hotGenres.map((genre) => (
                <Link
                  key={genre}
                  to={`/category?genre=${encodeURIComponent(genre)}`}
                  className="px-2.5 py-1 rounded-full text-xs bg-background-200/70 text-foreground-300 hover:bg-primary-500 hover:text-foreground-50 transition-colors cursor-pointer"
                >
                  {genre}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">站内导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li>
                <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="hover:text-accent-500 transition-colors cursor-pointer">
                  影视分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-accent-500 transition-colors cursor-pointer">
                  搜索结果
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-500 transition-colors cursor-pointer">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">内容说明</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-500">
              <li>
                <Link
                  to="/about#scope"
                  className="hover:text-accent-500 transition-colors cursor-pointer"
                >
                  内容范围
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="hover:text-accent-500 transition-colors cursor-pointer"
                >
                  联系与反馈
                </Link>
              </li>
              <li>
                <Link
                  to="/about#policy"
                  className="hover:text-accent-500 transition-colors cursor-pointer"
                >
                  版权声明
                </Link>
              </li>
              <li>
                <Link
                  to="/about#policy"
                  className="hover:text-accent-500 transition-colors cursor-pointer"
                >
                  隐私说明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2025 淫乱小镇 · 本站仅提供影视作品的剧情介绍与评论内容，不提供任何在线播放或下载服务。
          </p>
          <p className="text-xs text-foreground-600">
            内容为演示用途 · 所有作品均为虚构设定 · 仅供影视讨论交流
          </p>
        </div>
      </div>
    </footer>
  );
}